document.addEventListener("DOMContentLoaded", function () {
  const financeHeader = document.querySelector(".finance-header");
  const financeBlock = document.querySelector(".finance-block");

  if (financeHeader && financeBlock) {
    financeHeader.addEventListener("click", function () {
      financeBlock.classList.toggle("collapsed");
    });
  }
});